
import React, { useEffect } from 'react';
import { UltraSimpleChatScreen } from './UltraSimpleChatScreen';

const ChatScreen = () => {
  // Apply chat-specific CSS class to body
  useEffect(() => {
    document.body.classList.add('chat-page');
    
    return () => {
      document.body.classList.remove('chat-page');
    };
  }, []);

  return <UltraSimpleChatScreen />;
};

export default ChatScreen;
